
export function isNameValid(name: string) {
    return name.trim().length > 2;
}

export function validateMobile(mobile: string) {
    if (mobile.trim().length < 10) {
        return false;
    }

    return /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(mobile);
}

export function validateMail(mail: string) {
    if (mail.trim().length < 6) {
        return false;
    }

    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(mail);
}